import { useMemo, useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';

const resources = [
  {
    id: 1,
    category: 'Helplines',
    type: 'emergency',
    icon: 'ri-alarm-warning-fill',
    iconBg: 'bg-red-100',
    iconColor: 'text-red-500',
    title: 'National Emergency Hotline',
    desc: 'For immediate danger, violence, abuse, medical emergencies, or situations requiring immediate police or emergency response.',
    details: [
      'Emergency: 911',
      'Available nationwide',
    ],
    action: 'Call 911',
    phone: '911',
    featured: true,
  },
  {
    id: 2,
    category: 'Helplines',
    icon: 'ri-government-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-400',
    title: 'DSWD SWAD Laguna — Sta. Cruz',
    desc: 'Provincial social welfare assistance, crisis intervention, child protection referrals, and social welfare services for Laguna.',
    details: [
      'Address: N. Tobias St., Brgy. Poblacion V, Sta. Cruz, Laguna',
      'Contact: 0968-768-8404',
    ],
    action: 'Call SWAD Laguna',
    phone: '09687688404',
  },
  {
    id: 3,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Sta. Maria, Laguna',
    desc: 'For urgent incidents in Sta. Maria, contact emergency services first. For child protection concerns, coordinate with the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 4,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Mabitac, Laguna',
    desc: 'For urgent incidents in Mabitac, contact emergency services first. Child protection cases may also be referred to the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 5,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Famy, Laguna',
    desc: 'For urgent incidents in Famy, contact emergency services first. Child protection concerns may be coordinated with the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 6,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Siniloan, Laguna',
    desc: 'For urgent incidents in Siniloan, contact emergency services first. Local government offices can assist with welfare concerns and referrals.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 7,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Pangil, Laguna',
    desc: 'For urgent incidents in Pangil, contact emergency services first. Child protection concerns may be referred through the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 8,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Pakil, Laguna',
    desc: 'For urgent incidents in Pakil, contact emergency services first. Child protection concerns may be referred through the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 9,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Paete, Laguna',
    desc: 'For urgent incidents in Paete, contact emergency services first. Child protection concerns may be referred through the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 10,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Kalayaan, Laguna',
    desc: 'For emergency response, disaster assistance, police assistance, and child protection concerns in Kalayaan.',
    details: [
      'MDRRMO: 0916-904-9459',
      'MDRRMO Landline: (049) 523-3780',
      'PNP Kalayaan: 0998-598-5646',
      'PNP Kalayaan: 0967-630-4240',
      'PNP Landline: (049) 523-1815',
    ],
    action: 'Call MDRRMO',
    phone: '09169049459',
  },
  {
    id: 11,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Lumban, Laguna',
    desc: 'Official emergency contacts for Lumban, including local disaster response and police assistance.',
    details: [
      'Emergency: 911',
      'LDRRMO: 0965-395-1431',
      'LGU Lumban: 0917-164-2190',
      'Lumban MPS: 0998-598-5651',
      'Lumban MPS: 0963-420-1016',
      'BFP: 0951-294-9285',
    ],
    action: 'Call LDRRMO',
    phone: '09653951431',
  },
  {
    id: 12,
    category: 'Helplines',
    icon: 'ri-shield-user-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    title: 'Pagsanjan, Laguna',
    desc: 'For urgent incidents in Pagsanjan, contact emergency services first. Child protection concerns may be referred through the municipal social welfare office or DSWD SWAD Laguna.',
    details: [
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call Emergency',
    phone: '911',
  },
  {
    id: 13,
    category: 'Helplines',
    icon: 'ri-police-car-fill',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-400',
    title: 'PNP Women and Children Protection Desk',
    desc: 'For police assistance involving women and children protection cases. In an emergency, call 911 or proceed to the nearest police station.',
    details: [
      'Emergency: 911',
      'For Women and Children Protection concerns',
    ],
    action: 'Call 911',
    phone: '911',
  },
  {
    id: 14,
    category: 'Helplines',
    icon: 'ri-government-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-400',
    title: 'DSWD Field Office IV-A Crisis Intervention',
    desc: 'DSWD crisis intervention assistance for individuals and families experiencing urgent social welfare concerns.',
    details: [
      'Crisis Intervention Section: 0968-768-8392',
      'DSWD Field Office IV-A',
    ],
    action: 'Call DSWD',
    phone: '09687688392',
  },
  {
    id: 15,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Sta. Maria',
    desc: 'Municipal social welfare assistance and child protection referral services for residents of Sta. Maria, Laguna.',
    details: [
      'Area: Sta. Maria, Laguna',
      'Emergency: 911',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Visit Office',
  },
  {
    id: 16,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Mabitac',
    desc: 'Municipal social welfare assistance, family support, child protection referrals, and welfare services for Mabitac residents.',
    details: [
      'Area: Mabitac, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 17,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Famy',
    desc: 'Social welfare assistance, family intervention, child protection services, and crisis support for Famy residents.',
    details: [
      'Area: Famy, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 18,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Siniloan',
    desc: 'Municipal social welfare services and referral support for child protection and family welfare concerns.',
    details: [
      'Area: Siniloan, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 19,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Pangil',
    desc: 'Local social welfare office for child protection reporting, case referral, and assistance within Pangil.',
    details: [
      'Area: Pangil, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 20,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Pakil',
    desc: 'Municipal office for reporting child welfare concerns and requesting social services assistance.',
    details: [
      'Area: Pakil, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 21,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Paete',
    desc: 'Local social welfare support, child protection assistance, and referral services for Paete residents.',
    details: [
      'Area: Paete, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 22,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Kalayaan',
    desc: 'Local social welfare assistance and child protection referrals for residents of Kalayaan.',
    details: [
      'Area: Kalayaan, Laguna',
      'MDRRMO: 0916-904-9459',
      'PNP: 0998-598-5646',
    ],
    action: 'Visit Office',
  },
  {
    id: 23,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Lumban',
    desc: 'Municipal social welfare assistance, child protection reporting, and local welfare referrals.',
    details: [
      'Area: Lumban, Laguna',
      'LDRRMO: 0965-395-1431',
      'LGU: 0917-164-2190',
    ],
    action: 'Visit Office',
  },
  {
    id: 24,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Pagsanjan',
    desc: 'Municipal social welfare office for family, child, and community support services.',
    details: [
      'Area: Pagsanjan, Laguna',
      'Emergency: 911',
    ],
    action: 'Visit Office',
  },
  {
    id: 25,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
    title: 'MSWDO Sta. Cruz',
    desc: 'Municipal social welfare and development services for Sta. Cruz residents and nearby communities.',
    details: [
      'Area: Sta. Cruz, Laguna',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call SWAD Laguna',
    phone: '09687688404',
  },
  {
    id: 26,
    category: 'Organizations',
    icon: 'ri-government-line',
    iconBg: 'bg-indigo-50',
    iconColor: 'text-indigo-500',
    title: 'Laguna Provincial Social Welfare Office',
    desc: 'Provincial-level social welfare coordination for child protection, crisis intervention, and referral services across Laguna.',
    details: [
      'Location: Sta. Cruz, Laguna',
      'DSWD SWAD Laguna: 0968-768-8404',
    ],
    action: 'Call SWAD Laguna',
    phone: '09687688404',
  },
  {
    id: 27,
    category: 'Organizations',
    icon: 'ri-scales-3-line',
    iconBg: 'bg-indigo-50',
    iconColor: 'text-indigo-500',
    title: 'MCTC Pangil–Paete–Pakil',
    desc: 'Municipal Circuit Trial Court serving Pangil, Paete, and Pakil for court-related legal proceedings.',
    details: [
      'Location: San Jose, Pangil, Laguna',
      'Emergency: 911',
    ],
    action: 'View Court',
  },
  {
    id: 28,
    category: 'Guides',
    icon: 'ri-road-map-line',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-500',
    title: 'Where to Report from Sta. Maria to Sta. Cruz',
    desc: 'For immediate danger, call 911. For social welfare and child protection concerns, contact the nearest MSWDO or DSWD SWAD Laguna in Sta. Cruz.',
    action: 'Read Guide',
  },
  {
    id: 29,
    category: 'Guides',
    icon: 'ri-file-list-3-line',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-500',
    title: 'What to Prepare Before Reporting',
    desc: 'Prepare the child’s basic information, incident details, location, possible witnesses, screenshots or photos if available, and your contact information if not anonymous.',
    action: 'Read Guide',
  },
  {
    id: 30,
    category: 'Guides',
    icon: 'ri-file-paper-2-line',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-500',
    title: 'How to File a Child Protection Report',
    desc: 'Step-by-step guidance for reporting abuse, neglect, exploitation, trafficking, and violence against children.',
    action: 'Read Guide',
  },
  {
    id: 31,
    category: 'Articles',
    icon: 'ri-shield-check-line',
    iconBg: 'bg-gray-50',
    iconColor: 'text-gray-500',
    title: 'Child Protection Support in Laguna',
    desc: 'Child protection concerns can be coordinated through municipal social welfare offices and DSWD SWAD Laguna in Sta. Cruz.',
    action: 'Read Article',
  },
  {
    id: 32,
    category: 'Articles',
    icon: 'ri-book-open-line',
    iconBg: 'bg-gray-50',
    iconColor: 'text-gray-500',
    title: 'Understanding Child Protection Services',
    desc: 'Overview of social welfare intervention, referral systems, counseling, and child protection mechanisms available to residents of Laguna.',
    action: 'Read Article',
  },
];

export default function VResourcesPage() {
  const [activeFilter, setActiveFilter] = useState('All');
  const [search, setSearch] = useState('');

  const filters = ['All', 'Helplines', 'Guides', 'Organizations', 'Articles'];

  const filteredResources = useMemo(() => {
    return resources.filter((item) => {
      const matchFilter =
        activeFilter === 'All' || item.category === activeFilter;

      const keyword = search.toLowerCase();

      const matchSearch =
        item.title.toLowerCase().includes(keyword) ||
        item.desc.toLowerCase().includes(keyword) ||
        item.category.toLowerCase().includes(keyword) ||
        item.details?.some((detail) =>
          detail.toLowerCase().includes(keyword)
        );

      return matchFilter && matchSearch;
    });
  }, [activeFilter, search]);

  return (
    <AppLayout title="Resources" breadcrumb={['Victim', 'Resources']}>
      <div className="max-w-5xl mx-auto space-y-4 sm:space-y-5 px-1 sm:px-0">

        <div className="relative">
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search resources..."
            className="w-full bg-white border border-gray-100 rounded-2xl py-4 pl-11 pr-4 text-sm outline-none focus:ring-2 focus:ring-orange-100 focus:border-orange-300"
          />
        </div>

        <div className="flex gap-2 sm:gap-3 overflow-x-auto pb-2 -mx-1 px-1">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap transition ${
                activeFilter === filter
                  ? 'bg-orange-500 text-white'
                  : 'bg-white text-gray-600 border border-gray-100 hover:bg-orange-50'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="space-y-4">
          {filteredResources.map((item) =>
            item.featured ? (
              <section
                key={item.id}
                className="bg-red-50 border border-red-200 rounded-2xl sm:rounded-3xl p-4 flex flex-col sm:flex-row sm:items-center gap-4"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div
                    className={`w-12 h-12 rounded-2xl ${item.iconBg} flex items-center justify-center flex-shrink-0`}
                  >
                    <i className={`${item.icon} ${item.iconColor} text-xl`} />
                  </div>

                  <div>
                    <h3 className="font-bold text-red-600 text-sm sm:text-base">
                      {item.title}
                    </h3>

                    <p className="text-xs sm:text-sm text-red-500">
                      {item.desc}
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => {
                    window.location.href = 'tel:911';
                  }}
                  className="bg-red-600 text-white font-bold px-5 py-3 rounded-2xl whitespace-nowrap w-full sm:w-auto"
                >
                  {item.action}
                </button>
              </section>
            ) : (
              <ResourceCard key={item.id} item={item} />
            )
          )}

          {filteredResources.length === 0 && (
            <div className="bg-white border border-gray-100 rounded-3xl p-8 text-center">
              <i className="ri-search-eye-line text-4xl text-gray-300" />

              <p className="text-gray-500 mt-3 text-sm">
                No resources found.
              </p>
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
}

function ResourceCard({ item }: { item: any }) {
  const handleAction = () => {
    if (item.phone) {
      window.location.href = `tel:${item.phone}`;
    }
  };

  return (
    <section className="bg-white border border-gray-100 rounded-2xl sm:rounded-3xl p-4 sm:p-5 shadow-sm hover:shadow-md transition">
      <div className="flex items-start gap-3 sm:gap-4">
        <div
          className={`w-11 h-11 sm:w-12 sm:h-12 rounded-2xl ${item.iconBg} flex items-center justify-center flex-shrink-0`}
        >
          <i className={`${item.icon} ${item.iconColor} text-lg sm:text-xl`} />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-snug">
            {item.title}
          </h3>

          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mt-2">
            {item.desc}
          </p>

          {item.details && (
            <div className="mt-3 space-y-1">
              {item.details.map((detail: string) => (
                <p
                  key={detail}
                  className="text-[11px] sm:text-xs text-gray-500"
                >
                  {detail}
                </p>
              ))}
            </div>
          )}

          {item.phone ? (
            <button
              onClick={handleAction}
              className="mt-3 text-xs sm:text-sm font-semibold text-orange-600 hover:text-orange-700"
            >
              {item.action}
              <i className="ri-phone-line align-middle ml-1" />
            </button>
          ) : (
            <button
              type="button"
              className="mt-3 text-xs sm:text-sm font-semibold text-orange-600 hover:text-orange-700"
            >
              {item.action}
              <i className="ri-arrow-right-line align-middle ml-1" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
}